
import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { gridSimple, createGridConfig } from "./gridSettings/gridSettings";
import { movimentiRegistroRifiuto, movimentiRifiuto } from "./movimentiRifiuto";



let movimentiRifiutoMd = JSON.parse(JSON.stringify(movimentiRegistroRifiuto))
let complete =
    movimentiRifiutoMd = movimentiRifiutoMd.filter(resCol => {
        if (typeof resCol.data != 'undefined') {

            let data = resCol.data.filter(d => {
                //trasportatore_Descrizione_Sede destinatario_Descrizione_Sede
                if (d.dataField == "produttore_Descrizione_Sede" ||
                    d.dataField == "trasportatore_Descrizione_Sede" ||
                    d.dataField == "destinatario_Descrizione_Sede"
                ) {
                    if (d.dataField == 'produttore_Descrizione_Sede')
                        d.caption = 'Produttore'
                    if (d.dataField == 'trasportatore_Descrizione_Sede')
                        d.caption = 'Trasportatore'
                    if (d.dataField == 'destinatario_Descrizione_Sede')
                        d.caption = 'Destinatario'
                    d.colVisible = true;
                    return d
                }
                if (d.colVisible && d.dataField != "mostraScaricoR") {
                    return d
                }
            })

            resCol.data = data
            return resCol
        }
    })


///movimentiRifiutoMd =  movimentiRifiutoMd.filter(res=> res != undefined);
/*movimentiRifiutoMd[0].data.unshift(
    {
        type: 'campo',
        caption: 'Protocollo',
        labelVisible: true,
        colVisible: true,
        dataField: 'protocollo',
        dataType: '',
        order:4,
       
      }
)*/


movimentiRifiutoMd[0].data.unshift(
    {
        type: 'button',
        colVisible: true,
        orderGriglia: 1,
        colSpan: '4',
        colWidth: 40,
        dataField: "fissaRiga",
        class: 'text-center scarchi-click',
        caption: "",
        hideOnEdit: true,
        button: {
            text: 'fissaRiga',
            name: 'fissaRiga',
            location: 'after',
            class: 'fissaRiga',
            event: "fissaRiga",
            hint: "Fissa la riga",
            icon: 'glyphicon  mdi mdi-bookmark-outline',
            outPutValue: false,

        }

    }
)

let movimentiRifiutoPr = JSON.parse(JSON.stringify(movimentiRifiuto))
movimentiRifiutoPr = movimentiRifiutoPr.filter(resCol => {
    if (typeof resCol.data != 'undefined') {

        let data = resCol.data.filter(d => {

            if (d.colVisible && d.dataField != "mostraScaricoR") {
                return d
            }

        })

        resCol.data = data
        return resCol
    }
})
movimentiRifiutoPr[0].data.unshift(
    {
        type: 'campo',
        caption: 'Protocollo',
        labelVisible: true,
        colVisible: true,
        dataField: 'protocollo',
        dataType: '',


    }
)
let movimentiRifiutoMdProtofollati = movimentiRifiutoPr;

export const movimentiRifiutoRegistri: AnaColumn[] = movimentiRifiutoMd
export const movimentiRifiutoProtocollati: AnaColumn[] = movimentiRifiutoMdProtofollati

export const stampaRegistriFiltri: AnaColumn[] = [
    {

        configuration:
        {
            titleGriglia: 'Registri Carico e Scarico',
            titleForm: 'Stampa il registro di carico e scarico',
            breadcrumbCaption: 'Stampa registro C/S',
            campoTitle: 'edd',
            masterKey: 'id',
            helpDoc: 'Registrodicaricoescaricorifiuti.html',
            service: 'stampaRegistriFiltri',
            api: 'stampaRegistriFiltri',
            startTemplate: 'form',
            allowedAdvancedFilter: true,
            isAdvancedXlsExportAvailable: true,
            filterEditor: '/$',
            formType: 'simple',
            nCol: 1,
            toolbarSettings: {
                service: 'stampaRegistriFiltri',

            }

        }
    },

    {

        itemType: "group", caption: 'Gestione Registri', colCount: "4", colSpan: '1', data: [


            {
                type: 'customComponent', dataField: "listaGrid",
                colVisible: false,
                visible: true,
                component: {
                    nameComponent: 'NicaAnagraficaComponent',
                    name: 'listaGrid',
                    configuration: {
                        dataSetKey: '',
                        dataFieldToSend: '',
                        static: false,
                        service: 'StampaRegistiCSGrid',
                        api: 'registrorifiuti',
                        remoteOperations: true,
                        modifica: false,
                        aggiungi: false,
                        elimina: false,
                        ricerca: false,
                        soloRicercaGlobale: false,
                        gridHeight: 260,
                        gridWidth: 1700,
                        id: 'listaGrid',
                        orientamento: "l",
                        formato: "a4",
                        masterKey: "id",
                        dxocolumnchooser: false,
                        isExportPDFAvailable: false,
                        isExportDocxAvailable: false,
                        isExportExcelAvailable: false,
                        showResetFilterColumn: false,
                        showCheckBoxesMode: "always",
                        selectRow: "single"
                    }
                }
            },
            { type: 'empty', colVisible: true, dataField: "" },
            { type: 'empty', colVisible: true, dataField: "" },
            { type: 'empty', colVisible: true, dataField: "" },
        ]
    },

    {

        itemType: "group", groupDataField: 'reg', groupWidth: 750, caption: '', class: "", colCount: "3", colSpan: '1', data: [
            {

                type: 'campoSpecial', // il tipo di campo del form
                dataField: "idRegistro", // l'identificativo univoco del campo

                colSpan: '3',
                nCol: 10,
                caption: "Registro",
                disableOnUpdate: true,
                visible: false,
                validation: [
                    { type: "required", message: "Campo Obbligatorio" }
                ],

                dynamic: {
                    dataSource: 'registrorifiuti',
                    autocomplete: false,
                    valueExpr: 'id',
                    displayExpr: 'descrizione', // questo è campo che vogliamo vediamo dopo la selezione 
                    caption: "Elenco Registri",// titolo del popup che si apre
                    queryString: "",// quert stribg che gli passiamo se abbiao bisogbo di filtrare ulteriormente i dati "?nomeTabella=SOGGETTI"
                    componentType: 'dynamicGrid', // il tipo di componenti che si troverà all'interno del popup che apriamo                                                            
                    //related:['dataUltimoProtocolloStampato|infoAllaData','numeroUltimoProtocollo|infoUltimoProtocolloAssegnato'],
                    buttonOption: {
                        icon: 'glyphicon mdi mdi-playlist-plus',
                        hint: 'Sfoglia Registri',
                        name: 'Registri',
                        location: 'after', // a destra dell'input in cui ci troviamo in devstream

                    },
                    settingGrid: createGridConfig({
                        ...gridSimple,
                        colonne: [
                            {
                                dataField: 'sede_Descrizione',
                                caption: 'Unità locale',
                                dataType: "",
                                colSpan: 3,
                                allowEditing: false,
                                groupIndex: 0,
                            },
                            {
                                dataField: 'descrizione',
                                caption: 'Descrizione',
                                dataType: "",
                                colWidth: '300'
                            },
                            {
                                dataField: 'numeroUltimoProtocollo',
                                caption: 'N.Protocollo',
                                dataType: "",
                                colWidth: '150'
                            },
                            {
                                dataField: 'dataUltimoProtocolloStampato',
                                caption: 'Data Ultimo Protocollo Stampato',
                                dataType: "datetime",
                                colWidth: '150'
                            },
                            {
                                dataField: 'registroRentri',
                                caption: 'Reg. Rentri',
                                dataType: "",
                                colWidth: '150'
                            },
                        ]

                    })


                }
            },
            /*{
                type: 'empty',              
                caption:'Info ultima Stampa',
                colSpan: '3',
                nCol: 10,

            },*/
            {
                colSpan: '3', colVisible: false,
                nCol: 10,
                editorType: '', dataField: 'desRentri',
                hideInput: true, type: 'campoDescV',
                labelVisible: false,
                disabled: true,
                visible: false,
                editorClass: 'nero',
                attr: 'color:nero',
                class: 'nero',
                defaultValue: "qua2 bisognerebbe far uscire la descrizione rentri"
            },

            {
                colSpan: '3', colVisible: false, visible: false,
                nCol: 10,
                editorType: '', dataField: 'des',
                hideInput: true, type: 'campoDesc',
                class: 'verde',
                defaultValue: "Informazioni ultima elaborazione"
            },

            {
                type: 'campoData',
                dataType: 'date',
                dataField: 'infoDallaData',//'dataUltimoProtocolloStampato',
                caption: 'Data',
                nCol: 5,
                labelWidth: 160,
                //width:50,
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                attr: "text-align: left", // attr è lo style
                class: "",
                disabled: true,
                visible: false,
                //disableOnUpdate: true
            },
            // {
            //     type: 'empty',
            //     dataField: '',
            //     dataType: '',
            //     caption: '',
            //     colVisible: false,
            //     nCol: 2,

            // },
            /*{
                type: 'campoData',
                dataType: 'date',
                dataField: 'infoAllaData',//'dataUltimoProtocolloStampato',
                caption: 'Alla Data',               
                nCol:3,
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                attr: "text-align: left", // attr è lo style
                class: "",
                disabled:true,
            },*/

            {
                type: 'campo',
                dataType: 'number',
                dataField: 'infoUltimoProtocolloAssegnato',//'numeroUltimoProtocollo',
                caption: 'Ultimo protocollo',
                nCol: '3',
                //labelWidth:150,
                // format: "dd/MM/yyyy",
                //editorType: "dxDateBox",
                attr: "text-align: left", // attr è lo style
                class: "",
                disabled: true,
                visible: false,
                //disableOnUpdate: true
            },
            // 
            // {
            //     colSpan: '3', colVisible: false, visible: false,
            //     nCol: 10,
            //     editorType: '', dataField: 'des',
            //     hideInput: true, type: 'campoDesc',
            //     class: 'verde',
            //     defaultValue: "Parametri di elaborazione"
            // },
            {
                type: 'campo', // il tipo di campo del form
                dataField: "prossimoProtocolloDaAssegnare",
                nCol: 4,
                caption: "Prossimo Protoc.",
                acceptOnlyCharacters: environment.CHARACTERS_NUMBER_INPUT,
                showClearButton: false,
            },

            { type: 'empty', colVisible: true, dataField: "" },
            { type: 'empty', colVisible: true, dataField: "" },
            /*{
                type: 'campo', // il tipo di campo del form
                dataField: "ultimoProtocolloAssegnatoXX",
                caption: "Ultimo Protoc.",
                labelWidth:165,
                nCol:4,
                disableOnUpdate: true,
                showClearButton: false,
            },*/
            {
                type: 'campoData',
                dataType: 'date',
                dataField: 'daDataRegistrazione',
                caption: 'Dalla Data',
                nCol: 4,
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                attr: "text-align: left", // attr è lo style
                class: "",
                disableOnUpdate: true
            },
            {
                type: 'campoData',
                dataType: 'date',
                dataField: 'aDataRegistrazione',
                caption: 'Alla data',
                nCol: 3,
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                disableOnUpdate: false

            },
            { type: 'empty', colVisible: true, dataField: "" },
            /* {
                 type: 'campo',
                 dataField: 'consolida',
                 dataType: 'boolean',
                 caption: 'Consolida Movim.',
                 defaultValue:false,
                 colVisible: true,
                 nCol:3,
                 editorType:'dxCheckBox'
 
             },*/
            /*{
                            type: 'empty',
                            dataField: '',
                            dataType: '',
                            caption: '',
                            colVisible: false,
                            nCol: 0,
            
                        },*/
            {
                type: 'campo',
                dataField: 'elaboraMovimenti',
                dataType: 'boolean',
                caption: 'Visualizza Mov.',
                colVisible: false,
                visible: false,
                // colSpan:1,
                nCol: 3,

                editorType: 'dxCheckBox',

            },
            /*{
                type: 'campo',
                dataField: 'soloMovimentiConsolidati',
                dataType: 'boolean',
                caption: 'Solo Movimenti protocollati',
                colVisible: false,
                //colSpan:1,
                nCol:4,
                editorType:'dxCheckBox'
            },*/
            {
                type: 'campo', // il tipo di campo del form
                nCol: 2,
                hideOnEdit: true,
                class: 'd-none',
                dataField: "campoOptionalProtocollo", // l'identificativo univoco del campo
                caption: "",

            },

            { type: 'empty', colVisible: true, dataField: "" },
            { type: 'empty', colVisible: true, dataField: "" },
            { type: 'empty', colVisible: true, dataField: "" },
            {
                type: 'campoSpecial',
                dataField: 'opzioneProtocolli',
                caption: 'Tipo Registrazione ',
                nCol: 4,
                labelWidth: 115,
                colVisible: false,
                editorType: 'selectBox',
                lista: {
                    items: [
                        { id: 0, tipo: 'Tutte' },
                        { id: 1, tipo: 'Protocollate' },
                        { id: 2, tipo: 'Da Protocollare' },
                    ],
                    dataSource: '',//'ModelloDiStampa',
                    valueExpr: 'id',
                    displayExpr: 'tipo',
                    static: true,
                    showDropDownButton: true
                }
            },
            {
                type: 'campoSpecial',
                dataField: 'idModelloDiStampa',
                caption: 'Modello ',
                nCol: 3,
                // labelWidth: 47,
                colVisible: true,
                editorType: 'selectBox',
                lista: {
                    dataSource: "ModelloDiStampa",
                    queryString: "?$filter=(idCategoriaModello eq '500')",
                    valueExpr: 'id',
                    displayExpr: 'nomeModello',
                    static: false,
                    showDropDownButton: true
                }
            },
            //! IMPORTANTE PER LA STAMPA
            {
                type: 'campo',
                dataField: 'stampaDefinitiva',
                dataType: 'boolean',
                caption: 'Elab.Definitiva',
                defaultValue: false,
                class: 'd-none',
                colVisible: false,
                visible: true,
                nCol: 2,
                editorType: 'dxCheckBox'

            },
            {
                type: 'empty',
                dataField: '',
                dataType: '',
                caption: '',
                colVisible: false,
                nCol: 0,

            },

            /* {
                 type: 'campo',
                 colVisible: false,
                 dataField: "elaboraMovimenti",
                 dataType: "",
                 nCol: 6,
                 width: 500,
                 caption: "A che serve",
                 class: 'elabora-movimenti',
                 editorType:'dxCheckBox'
                  button: {
                     text: 'Elabora movimenti',
                     name: 'elaboraMovimenti',
                     location: 'after',
                     event: "elaboraMovimenti",
                     hint: "Mostra e gestisci l'elenco dei movimenti per la protocollazione",                   
                     outPutValue: false,
                 } 
             },*/
            //{ type: 'empty', dataField: ""},


            {
                type: 'campoDesc', // il tipo di campo del form
                nCol: 10,
                colSpan: 3,
                hideOnEdit: true,
                dataField: "descrizioneRegistroRentri", // l'identificativo univoco del campo
                caption: "",

            },
            {
                type: 'campo', // il tipo di campo del form
                nCol: 0,
                hideOnEdit: true,
                class: 'd-none',
                dataField: "RegistroRentri", // l'identificativo univoco del campo
                caption: "",
                editorType: 'dxCheckBox'
            },

            /* {
                type: 'simpleButton',
                colVisible: false,
                dataField: "elaboraMovimenti",
                dataType: "",
                nCol: 10,
                width: 100,
                caption: "",
                class: 'elabora-movimenti',
                button: {
                    text: 'Elabora movimenti',
                    name: 'elaboraMovimenti',
                    location: 'after',
                    event: "elaboraMovimenti",
                    hint: "Mostra e gestisci l'elenco dei movimenti per la protocollazione",
                    
                    outPutValue: false,


                }
            },
            {
                type: 'empty', // il tipo di campo del form

                dataField: "", // l'identificativo univoco del campo
            },
            {
                type: 'empty', // il tipo di campo del form

                dataField: "", // l'identificativo univoco del campo
            }, */

        ]
    },

    {

        itemType: "group", groupDataField: 'lista', caption: '', colCount: "4", colSpan: '1', data: [


            {
                type: 'campoGriglia',
                colVisible: false,
                dataField: "listaMovimenti",
                dataType: "",
                nCol: 10,
                colSpan: 4,
                width: 100,
                caption: "",

                class: '',
                formGrid: {
                    service: 'movimentiRifiutoRegistri',//'movimentiRifiutoProtocollati',
                    api: 'MovimentoRifiutiRegistroStampa/GetMovimentiRegistroRifiuti',
                    remoteOperation: true,
                    queryString: '?IdRegistro=$idRegistro&DallaData=$daDataRegistrazione&AllaData=$aDataRegistrazione&opzioneProtocolli=$campoOptionalProtocollo',
                    isEditable: false,
                    isEditableNewRow: false,
                    isEditableEditRow: false,
                    isEditableDeleteRow: false,
                    isOdata: false,
                    showToolbarTop: false,
                    tableHeight: 260,
                    tableWidth: 1700,
                    showFilter: false,
                    selectionRowMode: null,  // 'single' | 'detail' | 'multiple';
                    idTable: 'listaMovimenti',
                    isSearchable: false


                }
            },
        ]
    }

]